import { enableProdMode, LOCALE_ID } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'moment-duration-format';
import 'moment-timezone';
import { AppModule } from './app/app.module';
import { getLocale } from './app/_common/locale.const';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

const locale = getLocale();

platformBrowserDynamic([
	{ provide: LOCALE_ID, useValue: locale },
	{ provide: MAT_DATE_LOCALE, useValue: locale },
]).bootstrapModule(AppModule);
